"use client";

import { Nav } from "@/components/Nav";
import { Routes } from "@/lib/routes";
import Image from "next/image";
import Link from "next/link";
import { BurgerMenu } from "./BurgerMenu";
import styles from "./Header.module.css";

export const Header = () => {
  return (
    <header className={styles.header}>
      <Link href={Routes.MAIN} className={styles.logo}>
        <Image
          src={"/assets/images/logo.svg"}
          alt={"Логотип ЛАЙТ"}
          width={91}
          height={31.433}
        />
      </Link>
      <Nav
        classes={{
          nav: styles.nav,
          navLinks: styles["nav-links"],
          navLink: styles["nav-link"],
        }}
      />
      <BurgerMenu />
    </header>
  );
};
